<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/onlinecardresult/select"
      :model="formModel"
      :show="false"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
    >
      <el-form-item label="代理商ID/商户号">
        <el-input
          v-model="formModel.userId"
          placeholder="请输入代理商ID/商户号"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请人电话">
        <el-input
          v-model="formModel.Mobile"
          maxlength="11"
          placeholder="请输入申请人电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请人身份证">
        <el-input
          v-model="formModel.idCard"
          maxlength="50"
          placeholder="请输入申请人身份证"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请人姓名">
        <el-input
          v-model="formModel.realName"
          maxlength="50"
          placeholder="请输入申请人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="formModel.orderStatus">
          <el-option
            v-for="item in orderStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select v-model="formModel.typeCode">
          <el-option
            v-for="item in typeCode"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          v-model="formModel.orderNo"
          maxlength="50"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        type="index"
        label="序号"
        min-width="50"
      ></el-table-column>
      <el-table-column
        prop="userId"
        label="代理商ID/商户号"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="申请人姓名"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merMobile"
        label="申请人电话"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merIdCard"
        label="申请人身份证"
        min-width="300"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="300"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="bankName"
        label="信用卡名称"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="cardAmount"
        label="奖励金额（元）"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          {{ toDoubleThousands(scope.row.cardAmount) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderStatus"
        label="订单状态"
        min-width="130"
        :formatter="formatTranTypee"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="typeCode"
        label="订单类型"
        min-width="130"
        :formatter="formatTranTypeCode"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="操作日期"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="look(scope.row)">明细</el-button>
        </template>
      </el-table-column>
    </common-table>
    <show-info-dialog
      title="明细"
      :show="true"
      ref="showInfoDialog"
      class="showInfoDialog"
    >
      <common-table :data="tableData1" ref="commonTable" :isShow="false">
        <el-table-column
          prop="createTime"
          label="结算时间"
          min-width="130"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="stateName"
          label="结算阶段"
          min-width="130"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="amt"
          label="结算金额(元)"
          min-width="130"
          show-overflow-tooltip
          :formatter="formatterTableNumberYuan"
        ></el-table-column>
      </common-table>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import OnlineService from "service/OnlineService";
import TimeRange from "service/constant/TimeRange";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "onlinecardresult",
  data() {
    return {
      formModel: {
        userId: "",
        Mobile: "",
        idCard: "",
        realName: "",
        orderNo: "",
        orderStatus: "",
        typeCode: "",
        time: TimeRange.dayRange,
      },
      orderStatus: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "处理中",
        },
        {
          value: "1",
          label: "已完成",
        },
        {
          value: "2",
          label: "已拒绝",
        },
        {
          value: "3",
          label: "无效单",
        },
        {
          value: "4",
          label: "已结算",
        },
      ],
      typeCode: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "agent",
          label: "代理商端",
        },
        {
          value: "merchant",
          label: "商户端",
        },
      ],
      tableData: [],
      tableData1: [],
      submitService: OnlineService.onlinecardresultList,
      page: {},
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
  },
  mounted() {
    this.page = this.$refs.commonTable.page;

    this.getList();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        userId: this.formModel.userId.trim(),
        Mobile: this.formModel.Mobile.trim(),
        idCard: this.formModel.idCard.trim(),
        realName: this.formModel.realName.trim(),
        orderStatus: this.formModel.orderStatus,
        typeCode: this.formModel.typeCode,
        orderNo: this.formModel.orderNo,
        startTime: this.formModel.time[0],
        endTime: this.formModel.time[1],
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length == 0) {
        delete this.params.startTime;
        delete this.params.endTime;
      }
      return this.params;
    },
    ...mapGetters(["userId"]),
  },
  methods: {
    formatTranTypee(row, column, cellValue) {
      let value = "";
      this.orderStatus.forEach((item) => {
        if (item.value == cellValue) {
          value = item.label;
        }
      });
      return value ? value : "--";
    },
    formatTranTypeCode(row, column, cellValue) {
      let value = "";
      this.typeCode.forEach((item) => {
        if (item.value == cellValue) {
          value = item.label;
        }
      });
      return value ? value : "--";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    // doSettle(item) {
    //   this.doLoad(
    //     OnlineService.cardCloseOrder,
    //     {
    //       id: item.id,
    //       userId: this.userId,
    //     },
    //     (res) => {
    //       this.doCheck(res, (res) => {
    //         const result = res.contents;
    //         this.showSuccess(result.optMsg);
    //         this.getList();
    //       });
    //     },
    //     "信息获取失败"
    //   );
    // },
    // look(item) {
    //   this.showConfirm("确定对该条数据进行结算操作吗？")
    //     .then(() => {
    //       this.doSettle(item);
    //     })
    //     .catch(() => {});
    // },
    look(scope) {
      this.dolook(scope);
      this.$refs.showInfoDialog.open();
    },
    dolook(scope) {
      this.doLoad(
        OnlineService.onlinecardresultLook,
        {
          orderId: scope.id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData1 = result;
          });
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OnlineApplicationCard/OnlineCardResult.vue